// extracted by mini-css-extract-plugin
export var backupIcon = "_mz-1";
export var image = "_mz-0";